import React from 'react'
import { useState } from "react";
import { Button } from "react-bootstrap";

export default function FullscreenToggle() {
    const [isFullscreen, setIsFullscreen] = useState(false);

    const enterFullscreen = () => {
    const elem = document.documentElement; // or a specific container
    
    if (elem.requestFullscreen) elem.requestFullscreen();
    else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
    else if (elem.msRequestFullscreen) elem.msRequestFullscreen();

    setIsFullscreen(true);
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
    else if (document.msExitFullscreen) document.msExitFullscreen();

    setIsFullscreen(false);
  };
  return (
    <Button
    variant="dark"
     onClick={isFullscreen ? exitFullscreen : enterFullscreen}>
      {isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
    </Button>
  )
}
